import { FC, ReactNode, useState } from 'react';
import { Box, alpha, lighten, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useScreenBreakpoints } from 'src/utils/screenBreakpoints';

interface StudentHeaderProps {
  children?: ReactNode;
}

const StudentHeader: FC<StudentHeaderProps> = () => {
  const theme = useTheme();
  const { isLargeScreen } = useScreenBreakpoints();
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Box
        sx={{
          flex: 1,
          height: '100%',

          '.MuiPageTitle-wrapper': {
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.trueWhite[5]
                : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(4)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? `0 1px 0 ${alpha(
                    lighten(theme.colors.primary.main, 0.7),
                    0.15
                  )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
                : `0px 2px 4px -3px ${alpha(
                    theme.colors.alpha.black[100],
                    0.1
                  )}, 0px 5px 12px -4px ${alpha(
                    theme.colors.alpha.black[100],
                    0.05
                  )}`
          }
        }}
      >
        <Header menuClick={handleMenuClick} />
        <Sidebar open={isOpen} menuClick={handleMenuClick} />

        {isOpen ? (
          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              display: 'block',
              flex: 1,
              left: 0,
              ml: !isLargeScreen ? 'none' : `${theme.sidebar.width}`,
              mt: `${theme.header.height}`,
              transition: 'left 0.3s ease-in-out, margin-left 0.3s ease-in-out'
            }}
          >
            <Outlet />
            {!isLargeScreen && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.2)', 
                  zIndex: 2 
                }}
              />
            )}
          </Box>
        ) : (
          <Box
            sx={{
              position: 'relative',
              zIndex: 5,
              display: 'block',
              flex: 1,
              left: 0,
              mt: `${theme.header.height}`,
              transition: 'left 0.3s ease-in-out, margin-left 0.3s ease-in-out'
            }}
          >
            <Outlet />
          </Box>
        )}
      </Box>
    </>
  );
};

export default StudentHeader;
